import { render } from "./ActivateAccountView.vue?vue&type=template&id=69916026"
import script from "./ActivateAccountView.vue?vue&type=script&lang=js"
export * from "./ActivateAccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__